<div class="reminder" *ngIf="display">
    <h1>Welcome</h1>
    <p>
      You Must Download the Extension to Make FlyMSG Work. Don't Forget to PIN the "FM" in the Right Corner.
      {{
        extensionService.isChromeBrowser
          ? "If already installed, enable extension."
          : ""
      }}
    </p>
    <a [href]="site" target="_blank">
      <button
        id="downloadExtension"
        type="button"
        vng-button
        variant="primary"
        aria-label="Download Extension"
      >
        Download Extension
      </button>
    </a>
  </div>